import React, { useEffect, useRef } from 'react'
import { motion, useSpring, useTransform } from 'framer-motion'
import useMousePos from '../../hooks/useMousePos'
import useWindowSize from '../../hooks/useWindowSize';

const MoveAround = ({ ref, change, offsetValue, children }) => {

  const { pos } = useMousePos();
  const { W, H } = useWindowSize();
  const { onMobile } = useWindowSize();

  const moveSectionRef = useRef(null);

  // CONDITIONAL COMPONENT RENDER
  const MoveOnHover = !onMobile ? motion.div : "div";

  const spring = { stiffness: 200, damping: 50, mass: 1 };
  const motionX = useSpring(pos.x, spring);
  const motionY = useSpring(pos.y, spring);

  const offset = offsetValue || 10;
  const dir = !change ? 1 : -1
  const x = useTransform(motionX, [0, W - 50], [`${dir * offset}px`, `${dir * -offset}px`]);
  const y = useTransform(motionY, [0, H - 50], [`${offset * dir}px`, `${dir * -offset}px`]);

  useEffect(() => {
    const handleMouseMove = (event) => {
      if (moveSectionRef.current) {
        if (moveSectionRef.current.contains(event.target)) {
          const rect = moveSectionRef.current.getBoundingClientRect();
          motionX.set(event.clientX - rect.left);
          motionY.set(event.clientY - rect.top);
        }
      }
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [motionX, motionY]);


  return (
    <MoveOnHover ref={moveSectionRef} style={{ x, y: onMobile ? 0 : y }} className='flex flex-col relative center full pointer-events-auto *:select-none'>
      {children}
    </MoveOnHover>
  )
}

export default MoveAround